import { render, staticRenderFns } from "./SuggestOptions.vue?vue&type=template&id=cbe3b1c0"
import script from "./SuggestOptions.vue?vue&type=script&lang=js"
export * from "./SuggestOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports